<template>
  <div
    class="control__wrapper"
    :class="[
      `control--${skin}`,
      (modelValue.length > 0 || isFocus) && 'control__wrapper--focus',
    ]"
  >
    <input
      v-if="!isPhone"
      v-model="model"
      class="control__control"
      @focus="onFocus"
      @blur="onBlur"
    />
    <MaskInput
      v-else
      v-model="model"
      class="control__control"
      @focus="onFocus"
      @blur="onBlur"
      mask="+###########"
    />

    <div class="control__placeholder">{{ placeholder }}</div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed } from 'vue';
import { MaskInput } from 'vue-3-mask';

export default defineComponent({
  name: 'Input',

  components: {
    MaskInput,
  },

  props: {
    modelValue: {
      type: String,
      required: false,
      default: '',
    },
    skin: {
      type: String,
      required: false,
      default: 'default',
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    isPhone: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['update:modelValue'],

  setup(props, context) {
    const isFocus = ref(false);
    let onBlur: () => void;
    let onFocus: () => void;

    const model = computed({
      get() {
        return props.modelValue;
      },

      set(value) {
        return context.emit('update:modelValue', value);
      },
    });

    onBlur = () => {
      isFocus.value = false;
    };

    onFocus = () => {
      isFocus.value = true;
    };

    return {
      model,
      isFocus,
      onBlur,
      onFocus,
    };
  },
});
</script>

<style lang="stylus" scoped>
@import "~/src/assets/stylus/main.styl";

$name = '.control'

{$name}
  &__placeholder
    @extend $lineOverflow
    max-width calc(100% - 32px)
    position absolute
    top 10px
    left 16px
    color $colors.metropolis
    color var(--metropolis)
    transition all $effects.duration
    pointer-events none
    $text("sulguni")

  &__wrapper
    position relative
    width 100%
    height 40px

    &:hover
      .control__placeholder
        color $colors.troy
        color var(--troy)

    &:active,
    &--focus
      .control__control
        padding-top 18px

      .control__placeholder
        color $colors.metropolis
        color var(--metropolis)
        top 2px
        $text("briscola")

  &__control
    width 100%
    height 40px
    appearance none
    -webkit-appearance inherit
    transition all $effects.duration
    padding 2px 16px
    border none
    border-radius $border-radiuses.bana
    $text("sulguni")

  &--default
    {$name}__control
      color $colors.troy
      color var(--troy)
      background $colors.django
      background var(--django)

  &--map
    {$name}__control
      @extend $mediumShadow
      color $colors.harakiri
      color var(--harakiri)
      background $colors.amelie
      background var(--amelie)

    {$name}__wrapper
      &:active,
      &--focus
        .control__control
          box-shadow 0 4px 16px 0px $colors.hamiltonPressed
          box-shadow 0 4px 16px 0px var(--hamiltonPressed)
</style>
